import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// laravel-echo (broadcaster 'reverb') usa el protocolo Pusher por debajo.
(window as unknown as { Pusher: typeof Pusher }).Pusher = Pusher;

const key = (import.meta.env.VITE_REVERB_APP_KEY as string) || 'metrosafe-key';
const port = Number(import.meta.env.VITE_REVERB_PORT) || 6001;

// El WebSocket apunta al MISMO host desde el que se sirve la SPA (localhost o
// la IP de la LAN si entras desde el móvil) — igual que la API.
const wsHost = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const forceTLS = typeof window !== 'undefined' && window.location.protocol === 'https:';

const echo = new Echo({
    broadcaster: 'reverb',
    key,
    wsHost,
    wsPort: port,
    wssPort: port,
    forceTLS,
    enabledTransports: ['ws', 'wss'],
});

export default echo;
